// src/utils/pushNotifications.js
import { API_URLS } from '../config/api';

// 🛠️ Fonction vitale pour Safari : Convertir la clé VAPID au bon format binaire
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export const subscribeUserToPush = async () => {
  // 0. Vérification de base du navigateur
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    alert("❌ Les notifications Push ne sont pas supportées par ce navigateur.");
    return false;
  }

  try {
    // 1. Demande de permission explicite (Obligatoire pour iOS)
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      alert("❌ iOS a refusé la permission (Statut: " + permission + ").");
      return false;
    }

    // 2. Enregistrement et attente du Service Worker
    await navigator.serviceWorker.register('/sw.js');
    const registration = await navigator.serviceWorker.ready;
    
    if (!registration.pushManager) {
      alert("❌ PushManager introuvable. Êtes-vous bien sur l'application depuis l'écran d'accueil iOS ?");
      return false;
    }

    // 3. Récupération de la clé VAPID publique (via variables d'environnement)
    const publicVapidKey = "BMo_bKvRNjC_maEMCLCMjpf90aaDL7qGcw9Rz7ayMUFoJWHOK-JZrIwtLHhpHh_kolQrkOxxPGA_Z_BENvwaff4";
    if (!publicVapidKey) {
      alert("❌ Clé VAPID publique manquante ! Vérifiez vos variables d'environnement.");
      return false;
    }

    // 4. Inscription auprès d'Apple (C'est souvent ici que Safari bloque)
    let subscription;
    try {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicVapidKey)
      });
    } catch (subError) {
      alert("❌ Erreur d'abonnement Apple : " + subError.message);
      return false;
    }

    // 5. Récupération de l'utilisateur connecté
    const userInfoStr = sessionStorage.getItem('user_info');
    if (!userInfoStr) {
      alert("❌ Utilisateur non connecté ou session expirée.");
      return false;
    }
    const userInfo = JSON.parse(userInfoStr);

    // 6. Envoi de l'abonnement au serveur (Railway)
    const response = await fetch(API_URLS.SUBSCRIBE_PUSH, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        subscription: subscription, 
        user_id: userInfo.id 
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      alert("❌ Erreur Serveur Railway (" + response.status + ") : " + errorText);
      return false;
    }
    return true;

  } catch (error) {
    alert("❌ Erreur générale du script : " + error.message);
    console.error("Erreur détaillée:", error);
    return false;
  }
};